import React, { useState } from 'react';

import clsx from 'clsx';
import { PanelTopHeader } from '@/components/panels/PanelTopHeader/PanelTopHeader';
import { PanelTopSearch } from '@/components/panels/PanelTopSearch/PanelTopSearch';
import { ScrollArea } from '@/components/ui/scroll-area';
import { SectionFieldHero } from '../SectionFieldHero/SectionFieldHero';

import ImageTextAndImage from '@/assets/images/sections/hero/TextAndImage.png?format=webp';
import ImageTextAndImage2 from '@/assets/images/sections/hero/TextAndImage2.png?format=webp';
import ImageAndCenterText from '@/assets/images/sections/hero/ImageAndCenterText.png?format=webp';
import ImageTextLandscape from '@/assets/images/sections/hero/TextLandscapeImage.png?format=webp';
import ImageTextAndVideo from '@/assets/images/sections/hero/TextAndVideo.png?format=webp';

interface SectionProps {
  className: string;
  onSectionClick?: (sectionName: string) => void;
}

export const SectionHero: React.FC<SectionProps> = ({ className, onSectionClick }) => {
  const [searchTerm, setSearchTerm] = useState('');

  const handleClick = (sectionName: string) => {
    if (onSectionClick) {
      onSectionClick(sectionName);
    }
  };

  const heroSections = [
    { name: 'Text and image right side', imageSrc: ImageTextAndImage, sectionName: 'Section Hero' },
    { name: 'Text and image left side', imageSrc: ImageTextAndImage2, sectionName: 'Section Hero' },
    { name: 'Image and Center text', imageSrc: ImageAndCenterText, sectionName: 'Section Hero' },
    {
      name: 'Image and video right side',
      imageSrc: ImageTextAndVideo,
      sectionName: 'Section Hero',
    },
    {
      name: 'Text and landscape image',
      imageSrc: ImageTextLandscape,
      sectionName: 'Section Hero',
    },
  ];

  const filteredSections = heroSections.filter(({ name }) =>
    name.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  return (
    <div className={clsx(className, 'flex h-full max-w-[280px] flex-col')}>
      <PanelTopHeader
        className=""
        text={'Hero Section'}
        backButton={true}
        onClickClose={() => handleClick('')}
        onClickBtnBack={() => handleClick('Sections')}
      />
      <PanelTopSearch
        className=""
        placeholder="Search section..."
        text="Publish"
        onChange={(e) => setSearchTerm(e.target.value)}
        onSearch={(value: string) => setSearchTerm(value)}
      />

      <ScrollArea className="flex w-full flex-1 gap-1 overflow-hidden px-6">
        <div className="flex flex-col gap-3 px-1 py-3">
          {filteredSections.length === 0 ? (
            <p className="text-center text-neutral-500">No sections found</p>
          ) : (
            filteredSections.map(({ name, imageSrc, sectionName }) => (
              <SectionFieldHero
                key={name}
                name={name}
                className=""
                imageSrc={imageSrc}
                onClick={() => handleClick(sectionName)}
              />
            ))
          )}
        </div>
      </ScrollArea>
    </div>
  );
};
